import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid'

export const defaultSortModel: GridSortModel = [{ field: 'startDate', sort: 'desc' }]

export const defaultVisibilityModel: GridColumnVisibilityModel = {
  __newStatus: false,
  contractId: false,
  deal_end_date: false,
  dealStage: false,
  dealType: false,
  dealStatus: false,
  owner: false,
  _resolvedOwner: false,
  // Replaced by the Service Line (product_type) column — hidden by default
  // but still toggleable from the Columns menu.
  category_name: false,
  subcategory: false,
}

export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
export const defaultColumnOrder: string[] = [
  'productName',
  'product_type',
  'change_type',
  'grossProfit',
  'prior_gross_profit',
  'organizationName',
  'parentOrganizationName',
  'price',
  'netTotal',
  'mediaSpend',
  '_resolvedOwner',
  'dealName',
  'dealStatus',
  'dealType',
  'dealStage',
  'contractId',
  'category',
  'category_name',
  'subcategory',
  'status',
  'startDate',
  'endDate',
]
